export const MAP_SEVERITY_COLORS: string[] = ['#19A04B', '#F0C355', '#EB4B4B'];

export const SEVERITY_COLORS_10: string[] = ['#2FB966', '#FFCA28', '#F74141'];

export const MAP_DAE_COLORS_5: string[] = ['#DFFBE8', '#5FD2C8', '#2B9C92', '#165C56', '#062B27'];

export const MAP_SPRAY_COLORS_5: string[] = ['#EAF6FF', '#82CFFF', '#0092E4', '#005693', '#002747'];

export const MAP_SEVERITY_COLORS_5: string[] = ['#FFF3DD', '#F0C355', '#FF785A', '#CF3537', '#70191A'];

export const BASE_SEEDS_COLORS = ['#FDE725', '#98d44a', '#6ACC5B', '#159B8C', '#2d6d8b', '#3A538B', '#440154'];

export const BASE_PHENOLOGY_COLORS = [
  '#FDEC51',
  '#FFDC4A',
  '#FFC34C',
  '#FEA358',
  '#F37D66',
  '#D95A73',
  '#B93D79',
  '#98357C',
  '#7D3479',
  '#693476'
];

export const SEEDS_COLORS = [
  '#0071CD',
  '#5EBB7F',
  '#643AAA',
  '#5FD2C8',
  '#FF785A',
  '#9664F0',
  '#FFB2C1',
  '#005693',
  '#C17E19',
  '#2B9C92',
  '#F0C355',
  '#C6E6FF',
  '#0C612C',
  '#2E1954',
  '#A9EFE8',
  '#C1462B',
  '#D2BDF9',
  '#BB485D',
  '#002747',
  '#523305',
  '#165C56',
  '#9A6412'
];
